import { logFormData } from 'shared/lib/logFormData';
import type { TFormAnalyticsEventsOverrides } from 'shared/types/TFormAnalyticsEventsOverrides';

import type { TPassportFormFields } from 'entities/creditForm';
import { sendStepsAnalyticsEvents, setPassportInfo } from 'entities/creditForm';

import { PassportInfoTexts } from 'features/UpdatePassportInfo';

export const submitPassportForm =
  (actualData: TPassportFormFields, analyticsOverrides?: TFormAnalyticsEventsOverrides): ThunkResult<void> =>
  async (dispatch) => {
    logFormData('PassportInfo FormStep SubmitData', actualData);
    dispatch(sendStepsAnalyticsEvents([2], PassportInfoTexts, 'manual', analyticsOverrides));
    dispatch(setPassportInfo({ data: actualData }));
  };
